import { render, staticRenderFns } from "./SystemFeature.vue?vue&type=template&id=2edd4b6b&scoped=true&"
import script from "./SystemFeature.vue?vue&type=script&lang=js&"
export * from "./SystemFeature.vue?vue&type=script&lang=js&"
import style0 from "./SystemFeature.vue?vue&type=style&index=0&id=2edd4b6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd4b6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2edd4b6b')) {
      api.createRecord('2edd4b6b', component.options)
    } else {
      api.reload('2edd4b6b', component.options)
    }
    module.hot.accept("./SystemFeature.vue?vue&type=template&id=2edd4b6b&scoped=true&", function () {
      api.rerender('2edd4b6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemFeature.vue"
export default component.exports